import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { GET_SH_ACCESS_SCOPE, GET_SH_STRUCTURES } from '../client/graphql/index.js';
import { getShData } from '../client/utils/shData.js';
import { buildSportHubPublicStructureUrl } from '../utils/urlBuilder.js';
import buildSportHubNavigation from './navigation.js';

import '../client/scss/NavsAsideExtends.scss';

export const NavsAsideSecondary = ({
  secondaryRoutes,
  pagename,
  renderItemMenu,
  ManageAsideView,
  User,
  i18n,
}) => {
  const { data: accessScopeData, loading: loadingAccessScope } = useQuery(GET_SH_ACCESS_SCOPE, {
    fetchPolicy: 'cache-first',
  });
  const accessScope = accessScopeData?.MDB?._SH_?.accessScope;
  const navigation = buildSportHubNavigation({
    secondaryRoutes,
    accessScope: loadingAccessScope ? undefined : accessScope,
    user: User,
  });

  return renderItemMenu(navigation, 'secondary', pagename, ManageAsideView, i18n);
};

NavsAsideSecondary.propTypes = {
  secondaryRoutes: PropTypes.array.isRequired,
  pagename: PropTypes.string.isRequired,
  renderItemMenu: PropTypes.func.isRequired,
  ManageAsideView: PropTypes.func,
  User: PropTypes.object,
  i18n: PropTypes.object,
};

const NavsAsideExtends = ({ User, i18n, ManageAsideView }) => {
  const { data } = useQuery(GET_SH_STRUCTURES, { fetchPolicy: 'cache-first' });
  const structures = getShData(data)?.structures || [];
  const publicPageUrl = buildSportHubPublicStructureUrl({
    companyname: User?.companyname,
    structureId: structures[0]?.id,
  });

  const onPublicPageClick = (event) => {
    if (!publicPageUrl) event.preventDefault();
  };

  return (
    <div id="NavsAsideExtends_SH">
      <div className="sh-extends-actions">
        <div className="sh-extends-row">
          <a
            href={publicPageUrl || '#'}
            target={publicPageUrl ? '_blank' : undefined}
            rel={publicPageUrl ? 'noreferrer' : undefined}
            className={`btn btn--public-page${publicPageUrl ? '' : ' is-disabled'}`}
            aria-disabled={!publicPageUrl}
            onClick={onPublicPageClick}
          >
            {i18n.getResource(i18n.language, 'sport-hub', 'navsaside.publicpage')}
          </a>
          <Link
            to="/sport-hub/qrcode"
            className="btn btn--qr-code"
            onClick={() => ManageAsideView(false)}
          >
            <FontAwesomeIcon className="mr-1" icon={faQrcode} />{' '}
            {i18n.getResource(i18n.language, 'sport-hub', 'navsaside.qrcode')}
          </Link>
        </div>
      </div>
    </div>
  );
};

NavsAsideExtends.propTypes = {
  User: PropTypes.object,
  i18n: PropTypes.object.isRequired,
  ManageAsideView: PropTypes.func.isRequired,
};

export default NavsAsideExtends;
